import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGPathBGStyled from './SVGPathBG.styled';

class SVGPathBG extends Component {
  constructor(props) {
    super(props);
    this.pathRef = React.createRef();
    this.state = { pathLength: 0 };
  }

  componentDidMount() {
    this.setState({ pathLength: this.pathRef.current.getTotalLength() });
  }

  render() {
    const { pathLength } = this.state;
    const { svg, level } = this.props;

    const strokeGradient = viewport => (
      <defs>
        <linearGradient
          id={`gradient-${viewport}-${level}`}
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#00bc9b" />
          <stop offset="100%" stopColor="#5eaefd" />
        </linearGradient>
      </defs>
    );
    return (
      <React.Fragment>
        <SVGPathBGStyled pathLength={pathLength} viewBox={svg.viewBox}>
          {strokeGradient('landscape')}
          <path
            stroke={`url(#gradient-landscape-${level})`}
            ref={this.pathRef}
            d={svg.d}
            transform={svg.transform}
          />
        </SVGPathBGStyled>
      </React.Fragment>
    );
  }
}

export default SVGPathBG;

SVGPathBG.propTypes = {
  level: PropTypes.number.isRequired,
  svg: PropTypes.objectOf(PropTypes.string).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/SVGPathBG/SVGPathBG.js